import React, { useState, useEffect } from "react";
import "antd/dist/antd.min.css";
import {
  Row,
  Form,
  Menu,
  Affix,
  Button,
  Space,
  Drawer,
  Card,
  Input,
  Divider,
  Avatar,
  Select
} from "antd";
import {
  PoweroffOutlined,
  UserOutlined,
  MenuOutlined,
  FileSearchOutlined,
  FileAddOutlined,
  FileProtectOutlined,
  SettingOutlined,
  CloseOutlined,
  SaveOutlined,
  TeamOutlined,
  FileTextOutlined,
  InteractionOutlined,
  BankOutlined,
  PieChartOutlined,
  FundOutlined,
  PlusSquareOutlined,
  ReadOutlined,
  SolutionOutlined
} from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import swal from "sweetalert";

import "./index.css";

const { Option } = Select;

const layout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 }
};

const Header_title_c = props => {
  const [form1] = Form.useForm();

  let xURL = "";
  let xlocation = window.location.hostname;

  if (xlocation === "localhost") {
    xURL = "http://localhost:3002/api/";
  } else {
    xURL = "https://research.rihes.cmu.ac.th/api/";
  }

  const [visible, _Visible] = useState(false);
  const [visible2, _Visible2] = useState(false);

  const [xtitle_name, _xtitle_name] = useState("");
  const [xfirst_name_th, _xfirst_name_th] = useState("");
  const [xlast_name_th, _xlast_name_th] = useState("");
  const [xfirst_name_eng, _xfirst_name_eng] = useState("");
  const [xlast_name_eng, _xlast_name_eng] = useState("");
  const [xemp, _xemp] = useState("");
  const [xposition, _xposition] = useState("");
  const [xproject_position, _xproject_position] = useState("");
  const [xcenter, _xcenter] = useState("");
  const [xemail, _xemail] = useState("");
  const [xphone, _xphone] = useState("");
  const [xline, _xline] = useState("");

  const [show1, _show1] = useState(true);

  const [xEmp, _xEmp] = useState("");
  const [xPosition, _xPosition] = useState("");
  const [xProject_Position, _xProject_Position] = useState("");
  const [xCenter, _xCenter] = useState("");

  const [xEmpV, _xEmpV] = useState("");
  const [xPositionV, _xPositionV] = useState("");
  const [xProject_PositionV, _xProject_PositionV] = useState("");
  const [xCenterV, _xCenterV] = useState("");

  //const toggleButton = document.getElementsByClassName("toggle-button")[0];
  const navbarLinks = document.getElementsByClassName("navbar-links")[0];

  const [levelU, _levelU] = useState("");

  let logoutUrl = ``;
  if (xlocation === "localhost") {
    logoutUrl = `https://login.microsoftonline.com/cf81f1df-de59-4c29-91da-a2dfd04aa751/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURIComponent(
      "http://localhost:3000/login"
    )}`;
  } else {
    logoutUrl = `https://login.microsoftonline.com/cf81f1df-de59-4c29-91da-a2dfd04aa751/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURIComponent(
      "https://research.rihes.cmu.ac.th/login"
    )}`;
  }

  useEffect(() => {
    // console.log(props.research_id);
  }, []);

  const toggleClick = () => {
    navbarLinks.classList.toggle("active");
  };

  const onLogout = () => {
    localStorage.clear();
    window.location.href = logoutUrl;
  };

  const showDrawer = () => {
    _Visible(true);
  };

  const showDrawer2 = () => {
    _xtitle_name(props.tname ? props.tname.prename_TH : "");
    _xfirst_name_th(props.tname ? props.tname.firstname_TH : "");
    _xlast_name_th(props.tname ? props.tname.lastname_TH : "");
    _xfirst_name_eng(props.tname ? props.tname.firstname_EN : "");
    _xlast_name_eng(props.tname ? props.tname.lastname_EN : "");
    _xcenter(props.tname ? props.tname.organization_name_TH : "");
    _xposition(props.tname ? props.tname.itaccounttype_TH : "");
    _xemail(props.tname ? props.tname.cmuitaccount : "");

    _Visible2(true);
  };

  const onClose = () => {
    window.location.reload();
    _Visible(false);
  };

  const onClose2 = () => {
    _Visible2(false);
  };

  return (
    <Affix offsetTop={0} className="app__affix-header">
      <div>
        <nav className="navbar">
          <div
            className="brand-title"
            onClick={() => {
              window.location = "/Research_coordinator";
            }}
          >
            <Space>
              <img width={45} src="./RIHES_Logo-White.png" />

              <a
                style={{
                  fontWeight: "bold",
                  color: "white"
                }}
              >
                ระบบบริหารงานวิจัย
              </a>
            </Space>
          </div>

          <a href="#" class="toggle-button" onClick={toggleClick}>
            <span class="bar" />
            <span class="bar" />
            <span class="bar" />
          </a>

          <div className="navbar-links">
            <ul>
              <li>
                <a onClick={showDrawer}>
                  สวัสดี {(props.tname && props.tname.firstname_TH) || ""}{" "}
                </a>
              </li>
            </ul>
          </div>
        </nav>

        <Drawer
          title={(props.tname && props.tname.firstname_TH) || ""}
          closable={false}
          onClose={onClose}
          visible={visible}
          width={250}
        >
          <Menu>
            <Menu.Item key="6" onClick={showDrawer2}>
              <UserOutlined /> ข้อมูลส่วนตัว
            </Menu.Item>

            <Menu.Item key="7" onClick={onLogout}>
              <PoweroffOutlined /> ออกจากระบบ
            </Menu.Item>
          </Menu>

          <Drawer
            title="ข้อมูลส่วนตัว"
            closable={false}
            onClose={onClose2}
            visible={visible2}
            width={window.innerWidth > 1200 ? 600 : "auto"}
            extra={
              <Button
                icon={<CloseOutlined />}
                onClick={() => {
                  _Visible2(false);
                }}
              />
            }
          >
            <Card>
              <Form form={form1} initialValues={{}} {...layout}>
                <Row justify="center">
                  <Avatar size={100} icon={<UserOutlined />} />
                </Row>

                <Divider />

                <Form.Item label="ชื่อนำ" name="edtitle_name">
                  <Row>
                    <Input
                      disabled
                      style={{ width: "50%", color: "black" }}
                      value={xtitle_name}
                    />
                  </Row>
                </Form.Item>

                <Form.Item label="ชื่อ ภาษาไทย" name="edfirst_name_th">
                  <Row>
                    <Input
                      disabled
                      style={{ width: "100%", color: "black" }}
                      value={xfirst_name_th}
                    />
                  </Row>
                </Form.Item>

                <Form.Item label="นามสกุล ภาษาไทย" name="edlast_name_th">
                  <Row>
                    <Input
                      disabled
                      style={{ width: "100%", color: "black" }}
                      value={xlast_name_th}
                    />
                  </Row>
                </Form.Item>

                <Form.Item label="ชื่อ ภาษาอังกฤษ" name="edfirst_name_eng">
                  <Row>
                    <Input
                      disabled
                      style={{ width: "100%", color: "black" }}
                      value={xfirst_name_eng}
                    />
                  </Row>
                </Form.Item>

                <Form.Item label="นามสกุล ภาษาอังกฤษ" name="edlast_name_eng">
                  <Row>
                    <Input
                      disabled
                      style={{ width: "100%", color: "black" }}
                      value={xlast_name_eng}
                    />
                  </Row>
                </Form.Item>

                <Form.Item label="สังกัด/หน่วยงาน" name="edcenter">
                  <Row>
                    <Input
                      disabled
                      style={{ width: "100%", color: "black" }}
                      value={xcenter}
                    />
                  </Row>
                </Form.Item>

                <Form.Item label="ประเภท" name="edposition">
                  <Row>
                    <Input
                      disabled
                      style={{ width: "100%", color: "black" }}
                      value={xposition}
                    />
                  </Row>
                </Form.Item>

                <Form.Item label="E-mail" name="edemail">
                  <Row>
                    <Input
                      disabled
                      style={{ width: "100%", color: "black" }}
                      value={xemail}
                    />
                  </Row>
                </Form.Item>
              </Form>
            </Card>
          </Drawer>
        </Drawer>
      </div>
    </Affix>
  );
};
export default Header_title_c;
